import { useEffect, useState } from 'react'
import useAxiosPrivate from './useAxiosPrivate'
import { useAuthContext } from '../context/auth'
import socket from '../utils/socket'

// My own profile (name, email, avatar). Updates instantly when the avatar changes.
const useMyProfile = () => {
  const { auth } = useAuthContext()
  const axiosPrivate = useAxiosPrivate()
  const [profile, setProfile] = useState(null)

  const userId = auth?._id ? String(auth._id) : ''
  const hasToken = Boolean(auth?.accessToken)

  useEffect(() => {
    if (!hasToken || !userId) {
      setProfile(null)
      return
    }

    let cancelled = false
    axiosPrivate
      .get('/api/profile/me')
      .then(({ data }) => { if (!cancelled) setProfile(data) })
      .catch((err) => console.error('Unable to load profile', err))

    return () => { cancelled = true }
  }, [hasToken, userId, axiosPrivate])

  useEffect(() => {
    const onChanged = (e) => setProfile((p) => (p ? { ...p, ...e.detail } : p))
    const onSocket = ({ userId: id, avatar }) => {
      if (String(id) === userId) setProfile((p) => (p ? { ...p, avatar } : p))
    }

    window.addEventListener('profile:changed', onChanged)
    socket.on('profileUpdated', onSocket)
    return () => {
      window.removeEventListener('profile:changed', onChanged)
      socket.off('profileUpdated', onSocket)
    }
  }, [userId])

  return profile
}

export default useMyProfile